import { createAuthClient } from 'better-auth/react';

// A dead connection (a bar of signal but no data) leaves requests hanging rather than failing.
// Cutting auth requests off makes it count as "server unreachable", so the app opens in offline
// gig mode instead of waiting on the session check forever. (better-fetch's own `timeout` option
// is skipped whenever a signal is passed, which the session check always does.)
const AUTH_TIMEOUT_MS = 6000;

function fetchWithTimeout(input, init = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), AUTH_TIMEOUT_MS);
  const outer = init.signal;
  if (outer) {
    if (outer.aborted) controller.abort();
    else outer.addEventListener('abort', () => controller.abort(), { once: true });
  }
  return fetch(input, { ...init, signal: controller.signal }).finally(() => clearTimeout(timer));
}

// baseURL is empty — auth routes are served at /api/auth/* on the same origin
// (nginx proxies /api to the backend container)
export const authClient = createAuthClient({ fetchOptions: { customFetchImpl: fetchWithTimeout } });
